
import { updateAppConfig } from '#app'
import { defuFn } from '/Users/yuto.yasuoka/Project/chirashi-viewer/node_modules/defu/dist/defu.mjs'

const inlineConfig = {
  "nuxt": {
    "buildId": "c47beebc-586e-494e-8117-27c21b61fe12"
  }
}

// Vite - webpack is handled directly in #app/config
if (import.meta.hot) {
  import.meta.hot.accept((newModule) => {
    updateAppConfig(newModule.default)
  })
}



export default /* #__PURE__ */ defuFn(inlineConfig)
